<div class="backspinner" *ngIf="mode === 'indeterminate'">
	<div class="spinner-border" role="status">
		<span class="sr-only">Loading...</span>
	</div>
</div>
<section class="circle-step-sec" *ngIf="false">
	<div class="step-container d-flex">
		<span class="circlestep-wrap" [class]="colorFirstStep ? 'active-step' : ''">
			<span class="circle-step d-flex align-items-center justify-content-center">
				1
			</span>
			<p class="step-desc text-uppercase">Create An Account</p>
		</span>
		<span class="circlestep-wrap" [class]="colorSecondStep == true ? 'active-step' : ''">
			<span class="circle-step d-flex align-items-center justify-content-center">
				2
			</span>
			<p class="step-desc text-uppercase">
				{{ twoStepFlow ? 'Checkout' : 'Invite Friends' }}
			</p>
		</span>
		<span class="circlestep-wrap" *ngIf="!twoStepFlow" [class]="colorThirdStep == true ? 'active-step' : ''">
			<span class="circle-step d-flex align-items-center justify-content-center">
				{{ twoStepFlow ? 2 : 3 }}
			</span>
			<p class="step-desc text-uppercase">Checkout</p>
		</span>
	</div>
</section>
<!-- =========== SIGN UP FORM ========== -->
<section>
	<section class="payment-wrapper" *ngIf="!showNext && !health">
		<div class="container">
			<div class="pc-details d-flex justify-content-between flex-wrap">
				<div class="payment-details hideOnMobile">
					<img src="assets/images/stepper-banner.jpg" alt="image" />
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="subs-details" [class.managehealth-keypoints-panel]="isManageHealthBrand">
						<h2 class="servey-title show" *ngIf="plan_name || isManageHealthBrand">
							{{corpCoupon?corp_name : plan_name}}
						</h2>
						<h2 class="servey-title show" style="font-size: 2.2rem;"
							*ngIf="isPlanPurchased != 1 && isTrial == 1 && !freeRoute">
							{{noOfDay}}-Day Free Trial
						</h2>
						<div class="offers" *ngIf="!b2b">
							<a [href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'"
								class="btn login-btn strted-btn" [class.monthly]="flagForDiscountPlan"
								*ngIf="!corpOlaRoute">
								<span>
									Monthly <br> $14.90/mo
								</span>
							</a>
							<a [href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-yearly'"
								class="btn login-btn strted-btn" [class.yearly]="yearlyRoute" *ngIf="!corpOlaRoute">
								<span>
									Annual(50% off) <br> $89/yr
								</span>
							</a>
						</div>
						<ul class="list-details" *ngIf="details_plan && details_plan.length>0">
							<ng-container *ngFor="let d of details_plan">
								<li *ngIf="d.inPlan=='1'">
									<span class="tick-red">
										<img src="assets/images/tick-red.png" alt="">
									</span>
									{{d.sub_detail}}
								</li>
							</ng-container>
						</ul>
					</div>
					<div class="subsform">
						<h2 class="servey-title form-title">
							It's nice to meet you! Let's get started.
						</h2>
						<p *ngIf="!b2b && !corpOlaRoute">
							Tell us a bit about yourself to activate your
							<span *ngIf="isTrial">
								Free
								<span *ngIf="activeFreeTrial?.durationType && activeFreeTrial?.count">
									{{ activeFreeTrial?.count }}
									{{ activeFreeTrial?.durationType == "month" ? "mo": "" }}
								</span>
								trial.
							</span>
							<span *ngIf="!isTrial">account</span>
						</p>
						<span class="invalid-feedback">{{errorMessage}}</span>
						<form id="lead-create-account">
							<div class="form-group">
								<input name="nameFirstName" class="form-control" [(ngModel)]="firstName" type="text"
									placeholder="First Name*"
									onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
								<div class="invalid-feedback">
									<div *ngIf=" submiited && !firstName">
										Please enter your First name
									</div>
									<div *ngIf=" submiited && firstName?.length < 3">
										Please enter atleast 3 characters.
									</div>
								</div>
							</div>
							<div class="form-group">
								<input name="nameLastName" class="form-control" [(ngModel)]="lastName" type="text"
									placeholder="Last Name*"
									onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
								<div class="invalid-feedback">
									<div *ngIf=" submiited && !lastName">
										Please enter your Last name
									</div>
									<div *ngIf=" submiited && lastName?.length < 3">
										Please enter atleast 3 characters.
									</div>
								</div>

							</div>
							<div class="form-group">
								<input name="nameEmail" class="form-control" type="text" [(ngModel)]="email"
									placeholder="Email Address*">
								<div class="invalid-feedback">
									<div *ngIf=" submiited && !emailCheck(email)">
										Please enter your email address in the format yourname@example.com
									</div>
								</div>

							</div>
							<div class="form-group">
								<input name="namePassword" class="form-control" type="password" autocomplete
									[(ngModel)]="password" placeholder="Password*">
							</div>
							<div *ngIf="submiited && password?.length == 0" class="invalid-feedback">
								<p>Please enter the password.</p>
							</div>
							<div class="form-group">
								<input name="nameConfirmPassword" class="form-control" type="password" autocomplete
									[(ngModel)]="confirmPassword" placeholder="Confirm Password*">
							</div>
							<div *ngIf="submiited && confirmPassword !== password && confirmPassword?.length !== 0"
								class="invalid-feedback">
								<p>Password & Confirm Password Should Be Same.</p>
							</div>
							<div *ngIf="submiited && confirmPassword?.length == 0" class="invalid-feedback">
								<p>Please enter the confirm password.</p>
							</div>

							<div class="form-group" *ngIf="freeRoute">
								<input name="corporateCoupon" class="form-control" [(ngModel)]="corporateCoupon"
									[type]="corpCoupon?'hidden':'text'" placeholder="Enter coupon code*"
									(keyup)="corporateCouponCheck('html')">
								<div class="invalid-feedback">
									<div *ngIf="submiited && !isCouponValid">
										This is not a valid coupon
									</div>
									<div *ngIf="submiited && this.corporateCoupon?.length == 0">
										This is required field
									</div>
								</div>
							</div>

							<div class="form-group" *ngIf="yearlyRoute">
								<input name="corporateCoupon" class="form-control" [(ngModel)]="subcorporateCoupon"
									[type]="corpCoupon?'hidden':'text'" placeholder="Enter coupon code"
									(keyup)="subscriptiponCouponCheck('html')">
								<div class="invalid-feedback">
									<div *ngIf="submiited && !isSubsCouponValid">
										This is not a valid coupon
									</div>
								</div>
							</div>
							<a (click)="nextStep()" class="btn login-btn strted-btn">
								<span>
									Get Started
								</span>
							</a>
						</form>
						<div>
							<span *ngIf="!corpCoupon" style="margin: 5px;">Already a MyLifeWell.com member?
								<span class="cursorHand fontWt600" (click)="openloginmodal()">
									Log In
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<!--------------------------------Start Discount Form------------------------------>
	<section class="payment-wrapper" *ngIf="showDiscountForm">
		<div class="container">
			<div class="pc-details d-flex justify-content-between flex-wrap">
				<div class="payment-details hideOnMobile">
					<img src="assets/images/stepper-banner.jpg" alt="image" />
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="subs-details">
						<h2 class="servey-title show" *ngIf="plan_name">
							{{corpCoupon?corp_name : plan_name}}
						</h2>
						<h2 class="servey-title show" style="font-size: 2.2rem;"
							*ngIf="isPlanPurchased != 1 && isTrial == 1 && !freeRoute">
							{{noOfDay}}-Day Free Trial
						</h2>
						<div class="offers" *ngIf="!b2b">
							<a [href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'"
								class="btn login-btn strted-btn" [class.monthly]="monthlyRoute" *ngIf="!corpOlaRoute">
								<span>
									Monthly <br> $14.90/mo
								</span>
							</a>
							<a [href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-yearly'"
								class="btn login-btn strted-btn" [class.yearly]="annualyRoute" *ngIf="!corpOlaRoute">
								<span>
									Annual(50% off) <br> $89/yr
								</span>
							</a>
						</div>
						<ul class="list-details" *ngIf="details_plan && details_plan.length>0">
							<ng-container *ngFor="let d of details_plan">
								<li *ngIf="d.inPlan=='1'">
									<span class="tick-red">
										<img src="assets/images/tick-red.png" alt="">
									</span>
									{{d.sub_detail}}
								</li>
							</ng-container>
						</ul>
					</div>
					<div class="subsform">
						<h2 class="servey-title form-title">
							It's nice to meet you! Let's get started.
						</h2>
						<p *ngIf="!b2b && !corpOlaRoute">
							Tell us a bit about yourself to activate your
							<span *ngIf="isTrial">

								Free
								<span *ngIf="activeFreeTrial?.durationType && activeFreeTrial?.count">
									{{ activeFreeTrial?.count }}
									{{ activeFreeTrial?.durationType == "month" ? "mo": "" }}
								</span>
								trial.
							</span>
							<span *ngIf="!isTrial">account</span>

						</p>
						<span class="invalid-feedback">{{discountFormErrorMessage}}</span>
						<form id="lead-create-account" [formGroup]="discountForm">
							<div class="form-group">
								<input class="form-control" type="text" formControlName="dfName"
									placeholder="First Name*">
								<div *ngIf="submittedDiscount && d.dfName.errors" class="invalid-feedback">
									<div *ngIf="d.dfName.errors.required">First Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input class="form-control" type="text" formControlName="dlName"
									placeholder="Last Name*">
								<div *ngIf="submittedDiscount && d.dlName.errors" class="invalid-feedback">
									<div *ngIf="d.dlName.errors.required">First Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input class="form-control" type="email" formControlName="dEmail"
									placeholder="Email Address*">
								<div *ngIf="submittedDiscount && d.dEmail.errors" class="invalid-feedback">
									<div *ngIf="d.dEmail.errors.required">Email is required</div>
									<div *ngIf="d.dEmail.errors.email">Email must be a valid email address</div>
								</div>
							</div>
							<div class="form-group">
								<input class="form-control" type="password" autocomplete formControlName="dPassword"
									placeholder="Password*">
								<div *ngIf="submittedDiscount && d.dPassword.errors" class="invalid-feedback">
									<div *ngIf="d.dPassword.errors.required">Password is required</div>
									<div *ngIf="d.dPassword.errors.minlength">Password must be at least 6 characters
									</div>
								</div>
							</div>

							<div class="form-group">
								<input class="form-control" type="password" autocomplete
									formControlName="dConfirmPassword" placeholder="Confirm Password*">
								<div *ngIf="submittedDiscount && d.dConfirmPassword.errors" class="invalid-feedback">
									<div *ngIf="d.dConfirmPassword.errors.required">Password is required</div>
								</div>
								<div *ngIf="discountMatchPassword" style="color: red;">Password must be matched</div>
							</div>


							<!-- <div class="form-group" *ngIf="freeRoute">
								<input name="corporateCoupon" class="form-control" [(ngModel)]="corporateCoupon"
									[type]="corpCoupon?'hidden':'text'" placeholder="Enter coupon code*"
									(keyup)="corporateCouponCheck('html')">
								<div class="invalid-feedback">
									<div *ngIf="submiited && !isCouponValid">
										This is not a valid coupon
									</div>
									<div *ngIf="submiited && this.corporateCoupon?.length == 0">
										This is required field
									</div>
								</div>
							</div> -->

							<!-- <div class="form-group" *ngIf="yearlyRoute">
								<input name="corporateCoupon" class="form-control" [(ngModel)]="subcorporateCoupon"
									[type]="corpCoupon?'hidden':'text'" placeholder="Enter coupon code"
									(keyup)="subscriptiponCouponCheck('html')">
								<div class="invalid-feedback">
									<div *ngIf="submiited && !isSubsCouponValid">
										This is not a valid coupon
									</div>
								</div>
							</div> -->

							<!-- <div class="form-group" *ngIf="yearlyRoute">
								<input name="corporateCoupon" class="form-control" type="text"
									placeholder="Enter Company code" (keyup)="checkCouponForDiscount($event)">
								<div class="invalid-feedback">
									<div *ngIf="!isCouponValid">
										This is not a valid coupon
									</div>
									<div *ngIf="submittedDiscount && brnsnCouponCode == ''">
										This is required field
									</div>
								</div>
							</div> -->

							<a class="btn login-btn strted-btn" (click)="submitDiscountForm()">
								<span>
									Get Started
								</span>
							</a>
						</form>
						<div>
							<span *ngIf="!corpCoupon" style="margin: 5px;">Already a MyLifeWell.com member?
								<span class="cursorHand fontWt600" (click)="openloginmodal()">
									Log In
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!--------------------------------End Discount Form------------------------------>

	<!----------------------------Start Brnsn Section---------------------------------------->

	<section class="payment-wrapper" *ngIf="brnsn">
		<div class="container">
			<div class="pc-details d-flex justify-content-between flex-wrap">
				<div class="payment-details hideOnMobile">
					<img src="assets/images/stepper-banner.jpg" alt="image" />
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="subs-details">
						<h2 class="servey-title show" *ngIf="plan_name">
							{{corp_name?corp_name:'Bronson Helpnet'}}
						</h2>
						<!-- <ul class="list-details">
							<ng-container *ngFor="let d of details_plan">
								<li>
									<span class="tick-red">
										<img src="assets/images/tick-red.png" alt="">
									</span>
									{{d.sub_detail}}
								</li>
							</ng-container>
						</ul> -->
						<ul class="list-details">
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								2000+ health and fitness classes
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Guided meditations and calming music
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Pre loaded custom workouts
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Nutrition tracking including barcode scanner
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Community group for social wellness
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Custom challenges and rewards
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Priority access to exclusive packages & promotions
							</li>

						</ul>
					</div>
					<div class="subsform">
						<h2 class="servey-title form-title">
							It's nice to meet you! Let's get started.
						</h2>
						<span *ngIf="brnsnsMsg != ''" style="color: red;">{{brnsnsMsg}}</span>
						<form id="lead-create-account" [formGroup]="brnsnForm">
							<div class="form-group">
								<input formControlName="fName" class="form-control" type="text"
									placeholder="First Name*">
								<div *ngIf="submittedBrnsn && b.fName.errors" class="invalid-feedback">
									<div *ngIf="b.fName.errors.required">First Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="lName" class="form-control" type="text"
									placeholder="Last Name*">
								<div *ngIf="submittedBrnsn && b.lName.errors" class="invalid-feedback">
									<div *ngIf="b.lName.errors.required">Last Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="brnsnEmail" class="form-control" type="email"
									placeholder="Email Address*">
								<div *ngIf="submittedBrnsn && b.brnsnEmail.errors" class="invalid-feedback">
									<div *ngIf="b.brnsnEmail.errors.required">Email is required</div>
									<div *ngIf="b.brnsnEmail.errors.email">Email must be a valid email address</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="brnsnPassword" class="form-control" type="password" autocomplete
									placeholder="Password*">
								<div *ngIf="submittedBrnsn && b.brnsnPassword.errors" class="invalid-feedback">
									<div *ngIf="b.brnsnPassword.errors.required">Password is required</div>
									<div *ngIf="b.brnsnPassword.errors.minlength">Password must be at least 6 characters
									</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="brnsnConfirmPassword" class="form-control" type="password"
									autocomplete placeholder="Confirm Password*">
								<div *ngIf="submittedBrnsn && b.brnsnConfirmPassword.errors" class="invalid-feedback">
									<div *ngIf="b.brnsnConfirmPassword.errors.required">Password is required</div>
								</div>
							</div>

							<!-- <div class="form-group">
								<input formControlName="brnsnCoupon" class="form-control" placeholder="Enter Company Code*">
								<div *ngIf="submittedBrnsn && b.brnsnCoupon.errors" class="invalid-feedback">
									<div *ngIf="b.brnsnCoupon.errors.required">Company Code is required</div>
								</div>
							</div> -->

							<div class="form-group" *ngIf="corpCoupon == 'brnsn'">
								<input formControlName="brnsnCoupon" class="form-control" type="text"
									placeholder="Enter Company code*" (keyup)="checkCouponForBrnsn($event)">
								<div class="invalid-feedback" [class.d-block]="!isCouponValid || (submittedBrnsn && b.brnsnCoupon.errors)">
									<div *ngIf="!isCouponValid && brnsnCouponCode != ''">
										This is not a valid coupon
									</div>
									<div *ngIf="submittedBrnsn && b.brnsnCoupon.errors?.required">
										This is required field
									</div>
								</div>
							</div>


							<a class="btn login-btn strted-btn" (click)="submitBrnsn()">
								<span>
									Get Started
								</span>
							</a>
						</form>
						<div>
							<span style="margin: 5px;">Already a MyLifeWell.com member?
								<span class="cursorHand fontWt600">
									Log In
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<!----------------------------End Brnsn Section---------------------------------------->


	<!-----------------------------Start Section for Nature DRS----------------------------->
	<section class="payment-wrapper" *ngIf="natureDrs">
		<div class="container">
			<div class="pc-details d-flex justify-content-between flex-wrap">
				<div class="payment-details hideOnMobile">
					<img src="assets/images/stepper-banner.jpg" alt="image" />
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="subs-details">
						<h2 class="servey-title show" *ngIf="plan_name">
							{{corp_name?corp_name:'Nature DRS'}}
						</h2>

						<ul class="list-details">
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								2000+ health and fitness classes
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Guided meditations and calming music
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Pre loaded custom workouts
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Nutrition tracking including barcode scanner
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Community group for social wellness
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Custom challenges and rewards
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Priority access to exclusive packages & promotions
							</li>

						</ul>
					</div>
					<div class="subsform">
						<h2 class="servey-title form-title">
							It's nice to meet you! Let's get started.
						</h2>
						<span *ngIf="natureMsg != ''" style="color: red;">{{natureMsg}}</span>
						<form id="lead-create-account" [formGroup]="natureDrsForm">
							<div class="form-group">
								<input formControlName="firstName" class="form-control" type="text"
									placeholder="First Name*">
								<div *ngIf="submittedNature && n.firstName.errors" class="invalid-feedback">
									<div *ngIf="n.firstName.errors.required">First Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="lastName" class="form-control" type="text"
									placeholder="Last Name*">
								<div *ngIf="submittedNature && n.lastName.errors" class="invalid-feedback">
									<div *ngIf="n.lastName.errors.required">Last Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="natureEmail" class="form-control" type="email"
									placeholder="Email Address*">
								<div *ngIf="submittedNature && n.natureEmail.errors" class="invalid-feedback">
									<div *ngIf="n.natureEmail.errors.required">Email is required</div>
									<div *ngIf="n.natureEmail.errors.email">Email must be a valid email address</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="naturePassword" class="form-control" type="password"
									autocomplete placeholder="Password*">
								<div *ngIf="submittedNature && n.naturePassword.errors" class="invalid-feedback">
									<div *ngIf="n.naturePassword.errors.required">Password is required</div>
									<div *ngIf="n.naturePassword.errors.minlength">Password must be at least 6
										characters
									</div>
								</div>
							</div>

							<div class="form-group">
								<input formControlName="natureConfirmPassword" class="form-control" type="password"
									autocomplete placeholder="Confirm Password*">
								<div *ngIf="submittedNature && n.natureConfirmPassword.errors" class="invalid-feedback">
									<div *ngIf="n.natureConfirmPassword.errors.required">Password is required</div>
								</div>
							</div>

							<a class="btn login-btn strted-btn" (click)="submitNatureDrs()">
								<span>
									Get Started
								</span>
							</a>
						</form>
						<div>
							<span style="margin: 5px;">Already a MyLifeWell.com member?
								<span class="cursorHand fontWt600" (click)="openloginmodal()">
									Log In
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!------------------------------End Section for Nature DRS------------------------------>

	<!----------------------------Start Hollywood Section---------------------------------->
	<section class="payment-wrapper" *ngIf="hollywood">
		<div class="container">
			<div class="pc-details d-flex justify-content-between flex-wrap">
				<div class="payment-details hideOnMobile">
					<img src="assets/images/stepper-banner.jpg" alt="image" />
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="subs-details">
						<h2 class="servey-title show" *ngIf="plan_name">
							{{corp_name?corp_name:'City of Hollywood'}}
						</h2>
						<ul class="list-details">
							<ng-container *ngFor="let d of details_plan">
								<li>
									<span class="tick-red">
										<img src="assets/images/tick-red.png" alt="">
									</span>
									{{d.sub_detail}}
								</li>
							</ng-container>
						</ul>

					</div>
					<div class="subsform">
						<h2 class="servey-title form-title">
							It's nice to meet you! Let's get started.
						</h2>
						<span *ngIf="hollywoodMsg!= ''" style="color: red;">{{hollywoodMsg}}</span>
						<form id="lead-create-account" [formGroup]="hollywoodForm">
							<div class="form-group">
								<input formControlName="hollywoodFirstName" class="form-control" type="text"
									placeholder="First Name*">
								<div *ngIf="submittedHollywood && h.hollywoodFirstName.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodFirstName.errors.required">First Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodLastName" class="form-control" type="text"
									placeholder="Last Name*">
								<div *ngIf="submittedHollywood && h.hollywoodLastName.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodLastName.errors.required">Last Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodEmail" class="form-control" type="email"
									placeholder="Email Address*">
								<div *ngIf="submittedHollywood && h.hollywoodEmail.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodEmail.errors.required">Email is required</div>
									<div *ngIf="h.hollywoodEmail.errors.email">Email must be a valid email address</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodPassword" class="form-control" type="password"
									autocomplete placeholder="Password*">
								<div *ngIf="submittedHollywood && h.hollywoodPassword.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodPassword.errors.required">Password is required</div>
									<div *ngIf="h.hollywoodPassword.errors.minlength">Password must be at least 6
										characters
									</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodConfirmPassword" class="form-control" type="password"
									autocomplete placeholder="Confirm Password*">
								<div *ngIf="submittedHollywood && h.hollywoodConfirmPassword.errors"
									class="invalid-feedback">
									<div *ngIf="h.hollywoodConfirmPassword.errors.required">Password is required</div>
								</div>
							</div>

							<!-- <div class="form-group">
								<input formControlName="hollywoodCoupon" class="form-control"
									placeholder="Enter Company Code*">
								<div *ngIf="submittedHollywood && h.hollywoodCoupon.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodCoupon.errors.required">Company Code is required</div>
								</div>
							</div> -->
							<a class="btn login-btn strted-btn" (click)="submitHollywood('HOLLY')">
								<span>
									Get Started
								</span>
							</a>
						</form>
						<div>
							<span style="margin: 5px;">Already a MyLifeWell.com member?
								<span class="cursorHand fontWt600" (click)="openHollywoodLogin()">
									Log In
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!----------------------------------End Hollywood Section----------------------------------->

	<!----------------------------------Start Fun evo section here------------------------------->
	<section class="payment-wrapper" *ngIf="funevo">
		<div class="container">
			<div class="pc-details d-flex justify-content-between flex-wrap">
				<div class="payment-details hideOnMobile">
					<img src="assets/images/stepper-banner.jpg" alt="image" />
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="subs-details">
						<h2 class="servey-title show" *ngIf="plan_name">
							{{corp_name?corp_name:'Functionally Evolved'}}
						</h2>
						<!-- <ul class="list-details">
							<ng-container *ngFor="let d of details_plan">
								<li>
									<span class="tick-red">
										<img src="assets/images/tick-red.png" alt="">
									</span>
									{{d.sub_detail}}
								</li>
							</ng-container>
						</ul> -->
						<ul class="list-details">
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Tier Options (Tier 1 $30) (Tier 2 $40)
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								On Demand Low Impact Fitness Videos
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Meal tracker and barcode scanner
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Guided Meditations
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								5000+ movement library with 3D videos
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Monthly challenges and rewards
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Exclusive programs
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Easy cancellation process
							</li>
						</ul>

					</div>
					<div class="subsform">
						<h2 class="servey-title form-title">
							It's nice to meet you! Let's get started.
						</h2>
						<span *ngIf="hollywoodMsg!= ''" style="color: red;">{{hollywoodMsg}}</span>
						<form id="lead-create-account" [formGroup]="hollywoodForm">
							<div class="form-group">
								<input formControlName="hollywoodFirstName" class="form-control" type="text"
									placeholder="First Name*">
								<div *ngIf="submittedHollywood && h.hollywoodFirstName.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodFirstName.errors.required">First Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodLastName" class="form-control" type="text"
									placeholder="Last Name*">
								<div *ngIf="submittedHollywood && h.hollywoodLastName.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodLastName.errors.required">Last Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodEmail" class="form-control" type="email"
									placeholder="Email Address*">
								<div *ngIf="submittedHollywood && h.hollywoodEmail.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodEmail.errors.required">Email is required</div>
									<div *ngIf="h.hollywoodEmail.errors.email">Email must be a valid email address</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodPassword" class="form-control" type="password"
									autocomplete placeholder="Password*">
								<div *ngIf="submittedHollywood && h.hollywoodPassword.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodPassword.errors.required">Password is required</div>
									<div *ngIf="h.hollywoodPassword.errors.minlength">Password must be at least 6
										characters
									</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="hollywoodConfirmPassword" class="form-control" type="password"
									autocomplete placeholder="Confirm Password*">
								<div *ngIf="submittedHollywood && h.hollywoodConfirmPassword.errors"
									class="invalid-feedback">
									<div *ngIf="h.hollywoodConfirmPassword.errors.required">Password is required</div>
								</div>
							</div>

							<!-- <div class="form-group">
								<input formControlName="hollywoodCoupon" class="form-control"
									placeholder="Enter Company Code*">
								<div *ngIf="submittedHollywood && h.hollywoodCoupon.errors" class="invalid-feedback">
									<div *ngIf="h.hollywoodCoupon.errors.required">Company Code is required</div>
								</div>
							</div> -->
							<a class="btn login-btn strted-btn" (click)="submitHollywood('FUNEVO')">
								<span>
									Get Started
								</span>
							</a>
						</form>
						<div>
							<span style="margin: 5px;">Already a MyLifeWell.com member?
								<span class="cursorHand fontWt600" (click)="null">
									Log In
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!--------------------------------------End Fun evo here ---------------------------------->
	<!----------------------------------Start managed health section here------------------------------->
	<section class="payment-wrapper" *ngIf="health">
		<div class="container">
			<div class="pc-details d-flex justify-content-between flex-wrap">
				<div class="payment-details hideOnMobile">
					<img src="assets/images/stepper-banner.jpg" alt="image" />
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="subs-details">
						<h2 class="servey-title show" *ngIf="plan_name || isManageHealthBrand">
							<ng-container *ngIf="isManageHealthBrand; else healthBrandText">
								<span class="managehealth-heading-logo">
									<img src="assets/images/managehealthlogo.png" alt="ManageHealth logo">
								</span>
							</ng-container>
							<ng-template #healthBrandText>
								{{corp_name?corp_name:'Managed Health'}}
							</ng-template>
						</h2>

						<ul class="list-details">
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								2000+ health and fitness classes
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Guided meditations and calming music
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Pre loaded custom workouts
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Nutrition tracking including barcode scanner
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Community group for social wellness
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Custom challenges and rewards
							</li>
							<li>
								<span class="tick-red">
									<img src="assets/images/tick-red.png" alt="">
								</span>
								Priority access to exclusive packages & promotions
							</li>

						</ul>
					</div>
					<div class="subsform">
						<h2 class="servey-title form-title">
							It's nice to meet you! Let's get started.
						</h2>
						<span *ngIf="healthMsg != ''" style="color: red;">{{healthMsg}}</span>
						<form id="lead-create-account" [formGroup]="managedHealthForm">
							<div class="form-group">
								<input formControlName="firstName" class="form-control" type="text"
									placeholder="First Name*">
								<div *ngIf="submittedManagedHealth && m.firstName.errors" class="invalid-feedback">
									<div *ngIf="m.firstName.errors.required">First Name is required</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="lastName" class="form-control" type="text"
									placeholder="Last Name*">
								<div *ngIf="submittedManagedHealth && m.lastName.errors" class="invalid-feedback">
									<div *ngIf="m.lastName.errors.required">Last Name is required</div>
								</div>
							</div>
							<div class="form-group" *ngIf="isManageHealthBrand">
								<input formControlName="companyName" class="form-control" type="text"
									placeholder="Company Name*">
								<div *ngIf="submittedManagedHealth && m.companyName.errors" class="invalid-feedback">
									<div *ngIf="m.companyName.errors.required">Company Name is required</div>
								</div>
							</div>
							<div class="form-group" *ngIf="isManageHealthBrand">
								<select formControlName="userProfile" class="form-control">
									<option value="">Select User Profile*</option>
									<option value="Employee">Employee</option>
									<option value="Dependent">Dependent</option>
								</select>
								<div *ngIf="submittedManagedHealth && m.userProfile.errors" class="invalid-feedback">
									<div *ngIf="m.userProfile.errors.required">User Profile is required</div>
								</div>
							</div>
							<div class="form-group" *ngIf="isManageHealthBrand && managedHealthForm.get('userProfile')?.value === 'Dependent'">
								<input formControlName="parentAccountEmail" class="form-control" type="email"
									placeholder="Primary Account Email Id*">
								<div *ngIf="submittedManagedHealth && m.parentAccountEmail.errors" class="invalid-feedback">
									<div *ngIf="m.parentAccountEmail.errors.required">Primary Account Email Id is required</div>
									<div *ngIf="m.parentAccountEmail.errors.email">Primary Account Email Id must be a valid email address</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="healthEmail" class="form-control" type="email"
									placeholder="Email Address*">
								<div *ngIf="submittedManagedHealth && m.healthEmail.errors" class="invalid-feedback">
									<div *ngIf="m.healthEmail.errors.required">Email is required</div>
									<div *ngIf="m.healthEmail.errors.email">Email must be a valid email address</div>
								</div>
							</div>
							<div class="form-group">
								<input formControlName="healthPassword" class="form-control" type="password"
									autocomplete placeholder="Password*">
								<div *ngIf="submittedManagedHealth && m.healthPassword.errors" class="invalid-feedback">
									<div *ngIf="m.healthPassword.errors.required">Password is required</div>
									<div *ngIf="m.healthPassword.errors.minlength">Password must be at least 6
										characters
									</div>
								</div>
							</div>

							
							<div class="form-group">
								<input formControlName="healthConfirmPassword" class="form-control" type="password"
									autocomplete placeholder="Confirm Password*">
								<div *ngIf="submittedManagedHealth && m.healthConfirmPassword.errors" class="invalid-feedback">
									<div *ngIf="m.healthConfirmPassword.errors.required">Password is required</div>
								</div>
							</div>

							<a class="btn login-btn strted-btn" [class.managehealth-start-btn]="isManageHealthBrand" (click)="submitManagedHealth()">
								<span>
									Get Started
								</span>
							</a>
						</form>
						<div>
							<span style="margin: 5px;">Already a MyLifeWell.com member?
								<span class="cursorHand fontWt600" (click)="openloginmodal()">
									Log In
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!--------------------------------------End managed health here ---------------------------------->
	<section class="payment-wrapper">
		<span class="back" *ngIf="secondStepShow && false" (click)="goBackFromSecondStep()">
			Go back
		</span>
		<div class="container" *ngIf="mode === 'determinate'">
			<div class="facebook-invite text-center" *ngIf="secondStepShow && false">
				<div class="inv-wrp">
					<h2>
						Invite any 3 (maximum 7) friends and family members to claim your 3 month free membership.
					</h2>
					<p>
						Invited people will all receive the offer to claim a 3 month free membership.
						<br>
						MyLifeWell will only access the name and email of the people invited and no other data.
					</p>
					<a class="btn invite-btn" id="loginRef">
						Invite Now With
						<img src="../../../assets/images/logoForEmail/gmail.png" class="logoForEmailGmail">
					</a>
					<a class="btn invite-btn" (click)="signIn()" style="display: none;">
						Invite Now With
						<img src="../../../assets/images/logoForEmail/microsoft.png" class="logoForEmailMicrosoft">
					</a>
					<a class="btn invite-btn" (click)="personalizeInvite()">
						Invite Manually
					</a>
					<div>
						<a class="btn invite-btn" (click)="skip()">
							Skip To Checkout
						</a>
					</div>
					<div *ngIf="personalizeSection" style="margin-top: 5%;">
						<h6 class="text-center">
							Invite Minimum 3 to Claim 3-Month Free Membership
						</h6>
						<div *ngFor="let i of emailPersonalize?.controls;let in = index;"
							style="display: flex;margin-top: 2%;">
							<ng-container [formGroup]="i">
								<div style="width: 48%;">
									<input formControlName="name" placeholder="name" class="inputCss" />
									<div *ngIf="false && i?.get('name').hasError('required') && submittedPersonalizeEmailForm"
										class="error">
										Name is required.
									</div>
								</div>
								<div style="width: 48%;">
									<input formControlName="email" placeholder="email" class="inputCss" />
									<div *ngIf="false && i?.get('email').hasError('required') && submittedPersonalizeEmailForm"
										class="error">
										Email is required.
									</div>
								</div>
							</ng-container>
						</div>
						<button (click)="addMoreEmailPersonalize()" class="btnInEmailPersonalize">
							Add More
						</button>
						<button *ngIf="false && this.emailPersonalize?.length > 3"
							(click)="removeEmailPersonalize(this.emailPersonalize?.length - 1)"
							class="btnInEmailPersonalize">
							Remove Row
						</button>
						<button (click)="submitEmailPersonalize()" class="btnInEmailPersonalize">
							Send Invite
						</button>
					</div>
					<div *ngIf="emailFlag" style="margin-top: 20px;">
						<!-- Search In Google Other contacts  -->
						<div>
							<input name="nameGoogleSearchContact" [(ngModel)]="googleSearchContact" class="inputCss"
								placeholder="Search Contact From Google..." (keyup)="googleSearchEnableMethodCall()">
							<div class="text-center textSmall" *ngIf="googleOtherContactSerachMessage?.length > 0">
								{{ googleOtherContactSerachMessage }}
							</div>
						</div>
					</div>
					<div *ngIf="emailFlag" class="emailShowClass">
						<div>
							<span *ngFor="let i of selectedEmails" class="cursorHand" (click)="selectedEmailCall(i)"
								style="padding: 10px 15px;margin:5px;background-color: #eee;border-radius: 25px;">
								{{ i?.name }}
								<img src="../../../assets/images/close-icn.png" style="width: 10px;height: 15px;">
							</span>
						</div>
						<div *ngFor="let i of emailContactListArray;let in =index;"
							[class.activeEmail]="checkExist(i?.email)" class="paddingOne marginOne cursorHand"
							(click)="selectedEmailCall(i)">
							<input type="checkbox" [id]="'id'+in" [checked]="checkExist(i?.email)" class="float-left">
							<span>
								{{ i?.name }}
							</span>
							<span style="margin-left:15px">
								{{i?.email }}
							</span>
						</div>
						<div *ngIf="emailContactListArray?.length == 0">
							No Contact Found !!
						</div>
					</div>

					<div *ngIf="selectedEmails?.length <= 2 && selectedEmails?.length > 0">
						<div class="textSmall" style="margin-top: 10px;">
							Minimum 3 contact required to send invite !!
						</div>
					</div>
					<div *ngIf="selectedEmails?.length > 2">
						<a class="btn invite-btn" (click)="sendInvite()" *ngIf="!personalizeSection">
							Send Invite
						</a>
						<div *ngIf="popUpMessage?.length > 0" class="text-center textSmall">
							<p>{{ popUpMessage }}</p>
						</div>
					</div>
				</div>
			</div>
			<h4 class="congrats-msg text-center" *ngIf="showThirdStep && !secondStepSkipped">
				<span>Congratulations</span>
				You've activated your free membership!
			</h4>
			<div class="row" *ngIf="false && showThirdStep">
				<div class="col-md-12">
					<h2 class="text-center">
						Testimonials
					</h2>
				</div>
				<div class="col-md-3 testimonialCard" *ngFor="let i of testinomialData">
					<div class="cardUpPart">
						<img src="assets/images/openingQuotes.png" style="width: 25px;height: 20px;">
						<p>
							{{ i?.message }}
						</p>
					</div>
					<div class="cardDownPart">
						<div class="bottomPos">
							<div class="text-center fontWeight600">
								{{ i?.name }}
							</div>
							<div *ngIf="i?.rating >= 0" class="text-center">
								<ngb-rating [(rate)]="i.rating" [max]="5" style="pointer-events: none;">
									<ng-template let-fill="fill">
										<span class="star bad" [class.full]="fill === 100">
											<span class="half bad" [style.width.%]="fill">&#9733;</span>&#9733;
										</span>
									</ng-template>
								</ngb-rating>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="pc-details d-flex justify-content-between flex-wrap bbbbb" *ngIf="false && showThirdStep"
				style="margin-bottom: 40px;background-color: #f8f8f8;padding: 20px;">
				<div class="text-center w-100">
					<h4 class="congrats-msg text-center" style="color: #d42a55;">
						What MyLifeWell Customers Are Saying
					</h4>
				</div>
				<div class="payment-details d-md-flex w-100 testimonialSlick">
					<ngx-slick-carousel class="carousel" [config]="slideConfigForTestimonial">
						<div *ngFor="let i of testinomialData" ngxSlickItem>
							<div *ngIf="i?.rating >= 0" class="text-center">
								<ngb-rating [(rate)]="i.rating" [max]="5" style="pointer-events: none;">
									<ng-template let-fill="fill">
										<span class="star bad" [class.full]="fill === 100">
											<span class="half bad" [style.width.%]="fill">&#9733;</span>&#9733;
										</span>
									</ng-template>
								</ngb-rating>
								<div class="messageInTestimonial">
									{{ i?.message }}
								</div>

								<div class="nameInTestimonial">
									{{ i?.name }}
								</div>
								<div class="designationInTestimonial">
									({{ i?.designation }})
								</div>
							</div>
						</div>
					</ngx-slick-carousel>
				</div>
			</div>

			<!-- questionSection -->

			<!-- <div class="goto-premium  questionaireSection"
				*ngIf="newMiddleSection && questionSection && isTrialUsed != 1 && !showMiddleSection">
				<div class="container">
					<div class="premium-plan d-md-flex">
						<div class="premium-banner d-none d-md-block">
							<img src="assets/images/signUpFlow/bannerFitness.jpeg" alt="mylifewell">
						</div>
						<div class="plan-detail">
							<div class="">
								<small style="font-weight: 600;">

									To better personalize your MyLifeWell experience, please let us know:
								</small>
								<br />
								<h5 class="main-title">
									Select your top 3 wellness focus areas
								</h5>
							</div>
							<div class="checkBoxInput">
								<input id="improving_physical" type="Checkbox" name="blue" value="improving_physical"
									(change)="questionSelectionChange($event)">
								<label for="improving_physical" class="inputCheckboxText">
									Improving physical wellness
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="managing_stress" type="Checkbox" name="blue" value="managing_stress"
									(change)="questionSelectionChange($event)">
								<label for="managing_stress" class="inputCheckboxText">
									Managing stress
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="wellness_travel" type="Checkbox" name="blue" value="wellness_travel"
									(change)="questionSelectionChange($event)">
								<label for="wellness_travel" class="inputCheckboxText">
									Wellness travel planning
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="personal_coaching" type="Checkbox" name="blue" value="personal_coaching"
									(change)="questionSelectionChange($event)">
								<label for="personal_coaching" class="inputCheckboxText">
									Personal coaching
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="nutrition_tracking" type="Checkbox" name="blue" value="nutrition_tracking"
									(change)="questionSelectionChange($event)">
								<label for="nutrition_tracking" class="inputCheckboxText">
									Nutrition tracking and planning
								</label>
							</div>

							<div class="form-group text-left">
								<label class="txt-label" for="country">Country</label>
								<input class="form-control" name="country" id="country" [(ngModel)]="country"
									type="text">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="state">State</label>
								<input class="form-control" name="state" id="state" [(ngModel)]="state" type="text">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="city">City</label>
								<input class="form-control" name="city" id="city" [(ngModel)]="city" type="text">
							</div>

							<div class="checkBoxInput">
								<label>Your age group: </label><br>
								<div class="age-grp-radio">
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup1"
											(change)="onItemChange($event.target.value)" value="18-24">
										<label class="form-check-label" for="ageGroup1">18-24</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup2"
											(change)="onItemChange($event.target.value)" value="25-34">
										<label class="form-check-label" for="ageGroup2">25-34</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChange($event.target.value)" value="35-44">
										<label class="form-check-label" for="ageGroup3">35-44</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChange($event.target.value)" value="45-54">
										<label class="form-check-label" for="ageGroup3">45-54</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChange($event.target.value)" value="55-64">
										<label class="form-check-label" for="ageGroup3">55-64</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChange($event.target.value)" value="65+">
										<label class="form-check-label" for="ageGroup3">65+</label>
									</div>
								</div>
							</div>

							<div class="checkBoxInput redColor" *ngIf="errorMessageForQuestionaire">
								{{ errorMessageForQuestionaire }}
							</div>


							<div class="text-center">
								<button class="btn buttonInquestionaire" (click)="submitTheQuestionaire()">
									Get Started
								</button>
							</div>

						</div>
					</div>
				</div>
			</div> -->

			<!-- questionSection -->

			<!----------------------Start Question Section For bransn-------------------------->
			<!-- <div class="goto-premium  questionaireSection bbb" *ngIf="questionSectionforbrnsn">
				<div class="container">
					<div class="premium-plan d-md-flex">
						<div class="premium-banner d-none d-md-block">
							<img src="assets/images/signUpFlow/bannerFitness.jpeg" alt="mylifewell">
						</div>
						<div class="plan-detail">
							<div class="">
								<small style="font-weight: 600;">
									To better personalize your MyLifeWell experience, please let us know:
								</small>
								<br />
								<h5 class="main-title">
									Select your top 3 wellness focus areas
								</h5>
							</div>
							<div class="checkBoxInput">
								<input id="improving_physical" type="Checkbox" name="blue" value="improving_physical"
									(change)="questionSelectionChangeforBransn($event)">
								<label for="improving_physical" class="inputCheckboxText">
									Improving physical wellness
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="managing_stress" type="Checkbox" name="blue" value="managing_stress"
									(change)="questionSelectionChangeforBransn($event)">
								<label for="managing_stress" class="inputCheckboxText">
									Managing stress
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="wellness_travel" type="Checkbox" name="blue" value="wellness_travel"
									(change)="questionSelectionChangeforBransn($event)">
								<label for="wellness_travel" class="inputCheckboxText">
									Wellness travel planning
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="personal_coaching" type="Checkbox" name="blue" value="personal_coaching"
									(change)="questionSelectionChangeforBransn($event)">
								<label for="personal_coaching" class="inputCheckboxText">
									Personal coaching
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="nutrition_tracking" type="Checkbox" name="blue" value="nutrition_tracking"
									(change)="questionSelectionChangeforBransn($event)">
								<label for="nutrition_tracking" class="inputCheckboxText">
									Nutrition tracking and planning
								</label>
							</div>

							<div class="form-group text-left">
								<label class="txt-label" for="country">Country</label>
								<input type="text" class="form-control" name="countryforBransn" id="countryforBransn"
									[(ngModel)]="countryforBransn">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="state">State</label>
								<input type="text" class="form-control" name="stateforBransn" id="stateforBransn"
									[(ngModel)]="stateforBransn">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="city">City</label>
								<input type="text" class="form-control" name="cityforBransn" id="cityforBransn"
									[(ngModel)]="cityforBransn">
							</div>

							<div class="checkBoxInput">
								<label>Your age group: </label><br>
								<div class="age-grp-radio">
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup1"
											(change)="onItemChangeforBransns($event.target.value)" value="18-24">
										<label class="form-check-label" for="ageGroup1">18-24</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup2"
											(change)="onItemChangeforBransns($event.target.value)" value="25-34">
										<label class="form-check-label" for="ageGroup2">25-34</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforBransns($event.target.value)" value="35-44">
										<label class="form-check-label" for="ageGroup3">35-44</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforBransns($event.target.value)" value="45-54">
										<label class="form-check-label" for="ageGroup3">45-54</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforBransns($event.target.value)" value="55-64">
										<label class="form-check-label" for="ageGroup3">55-64</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforBransns($event.target.value)" value="65+">
										<label class="form-check-label" for="ageGroup3">65+</label>
									</div>
								</div>
							</div>

							<div class="checkBoxInput redColor" *ngIf="errorMessageForQuestionaireforBransn">
								{{ errorMessageForQuestionaireforBransn }}
							</div>


							<div class="text-center">
								<button class="btn buttonInquestionaire" (click)="submitTheQuestionaireforBransn()">
									Get Started
								</button>
							</div>

						</div>
					</div>
				</div>
			</div> -->

			<!----------------------End Question Section For bransn-------------------------->


			<!-----------------------Start Question Section For Nature DRS-------------------->
			<!-- <div class="goto-premium  questionaireSection" *ngIf="questionSectionforNature">
				<div class="container">
					<div class="premium-plan d-md-flex">
						<div class="premium-banner d-none d-md-block">
							<img src="assets/images/signUpFlow/bannerFitness.jpeg" alt="mylifewell">
						</div>
						<div class="plan-detail">
							<div class="">
								<small style="font-weight: 600;">
									To better personalize your MyLifeWell experience, please let us know:
								</small>
								<br />
								<h5 class="main-title">
									Select your top 3 wellness focus areas
								</h5>
							</div>
							<div class="checkBoxInput">
								<input id="improving_physical" type="Checkbox" name="blue" value="improving_physical"
									(change)="questionSelectionChangeforNature($event)">
								<label for="improving_physical" class="inputCheckboxText">
									Improving physical wellness
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="managing_stress" type="Checkbox" name="blue" value="managing_stress"
									(change)="questionSelectionChangeforNature($event)">
								<label for="managing_stress" class="inputCheckboxText">
									Managing stress
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="wellness_travel" type="Checkbox" name="blue" value="wellness_travel"
									(change)="questionSelectionChangeforNature($event)">
								<label for="wellness_travel" class="inputCheckboxText">
									Wellness travel planning
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="personal_coaching" type="Checkbox" name="blue" value="personal_coaching"
									(change)="questionSelectionChangeforNature($event)">
								<label for="personal_coaching" class="inputCheckboxText">
									Personal coaching
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="nutrition_tracking" type="Checkbox" name="blue" value="nutrition_tracking"
									(change)="questionSelectionChangeforNature($event)">
								<label for="nutrition_tracking" class="inputCheckboxText">
									Nutrition tracking and planning
								</label>
							</div>

							<div class="form-group text-left">
								<label class="txt-label" for="country">Country</label>
								<input type="text" class="form-control" name="countryforBransn" id="countryforBransn"
									[(ngModel)]="countryforBransn">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="state">State</label>
								<input type="text" class="form-control" name="stateforBransn" id="stateforBransn"
									[(ngModel)]="stateforBransn">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="city">City</label>
								<input type="text" class="form-control" name="cityforBransn" id="cityforBransn"
									[(ngModel)]="cityforBransn">
							</div>

							<div class="checkBoxInput">
								<label>Your age group: </label><br>
								<div class="age-grp-radio">
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup1"
											(change)="onItemChangeforNature($event.target.value)" value="18-24">
										<label class="form-check-label" for="ageGroup1">18-24</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup2"
											(change)="onItemChangeforNature($event.target.value)" value="25-34">
										<label class="form-check-label" for="ageGroup2">25-34</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforNature($event.target.value)" value="35-44">
										<label class="form-check-label" for="ageGroup3">35-44</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforNature($event.target.value)" value="45-54">
										<label class="form-check-label" for="ageGroup3">45-54</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforNature($event.target.value)" value="55-64">
										<label class="form-check-label" for="ageGroup3">55-64</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforNature($event.target.value)" value="65+">
										<label class="form-check-label" for="ageGroup3">65+</label>
									</div>
								</div>
							</div>

							<div class="checkBoxInput redColor" *ngIf="errorMessageForQuestionaireforNature">
								{{ errorMessageForQuestionaireforNature }}
							</div>


							<div class="text-center">
								<button class="btn buttonInquestionaire" (click)="submitTheQuestionaireforNature()">
									Get Started
								</button>
							</div>

						</div>
					</div>
				</div>
			</div> -->
			<!-----------------------End Question Section For Nature DRS----------------------->

			<!----------------------Start Question Section For Hollywood-------------------------->
			<!-- <div class="goto-premium  questionaireSection hhh" *ngIf="questionSectionforHollywood">
				<div class="container">
					<div class="premium-plan d-md-flex">
						<div class="premium-banner d-none d-md-block">
							<img src="assets/images/signUpFlow/bannerFitness.jpeg" alt="mylifewell">
						</div>
						<div class="plan-detail">
							<div class="">
								<small style="font-weight: 600;">
									To better personalize your MyLifeWell experience, please let us know:
								</small>
								<br />
								<h5 class="main-title">
									Select your top 3 wellness focus areas
								</h5>
							</div>
							<div class="checkBoxInput">
								<input id="improving_physical" type="Checkbox" name="blue" value="improving_physical"
									(change)="questionSelectionChangeforHollywood($event)">
								<label for="improving_physical" class="inputCheckboxText">
									Improving physical wellness
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="managing_stress" type="Checkbox" name="blue" value="managing_stress"
									(change)="questionSelectionChangeforHollywood($event)">
								<label for="managing_stress" class="inputCheckboxText">
									Managing stress
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="wellness_travel" type="Checkbox" name="blue" value="wellness_travel"
									(change)="questionSelectionChangeforHollywood($event)">
								<label for="wellness_travel" class="inputCheckboxText">
									Wellness travel planning
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="personal_coaching" type="Checkbox" name="blue" value="personal_coaching"
									(change)="questionSelectionChangeforHollywood($event)">
								<label for="personal_coaching" class="inputCheckboxText">
									Personal coaching
								</label>
							</div>
							<div class="checkBoxInput">
								<input id="nutrition_tracking" type="Checkbox" name="blue" value="nutrition_tracking"
									(change)="questionSelectionChangeforHollywood($event)">
								<label for="nutrition_tracking" class="inputCheckboxText">
									Nutrition tracking and planning
								</label>
							</div>

							<div class="form-group text-left">
								<label class="txt-label" for="country">Country</label>
								<input type="text" class="form-control" name="countryforHollywood"
									id="countryforHollywood" [(ngModel)]="countryforHollywood">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="state">State</label>
								<input type="text" class="form-control" name="stateforHollywood" id="stateforHollywood"
									[(ngModel)]="stateforHollywood">
							</div>
							<div class="form-group text-left">
								<label class="txt-label" for="city">City</label>
								<input type="text" class="form-control" name="cityforHollywood" id="cityforHollywood"
									[(ngModel)]="cityforHollywood">
							</div>

							<div class="checkBoxInput">
								<label>Your age group: </label><br>
								<div class="age-grp-radio">
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup1"
											(change)="onItemChangeforHollywood($event.target.value)" value="18-24">
										<label class="form-check-label" for="ageGroup1">18-24</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup2"
											(change)="onItemChangeforHollywood($event.target.value)" value="25-34">
										<label class="form-check-label" for="ageGroup2">25-34</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforHollywood($event.target.value)" value="35-44">
										<label class="form-check-label" for="ageGroup3">35-44</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforHollywood($event.target.value)" value="45-54">
										<label class="form-check-label" for="ageGroup3">45-54</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforHollywood($event.target.value)" value="55-64">
										<label class="form-check-label" for="ageGroup3">55-64</label>
									</div>
									<div class="form-check form-check-inline age-option">
										<input class="form-check-input" type="radio" name="ageGroup" id="ageGroup3"
											(change)="onItemChangeforHollywood($event.target.value)" value="65+">
										<label class="form-check-label" for="ageGroup3">65+</label>
									</div>
								</div>
							</div>

							<div class="checkBoxInput redColor" *ngIf="errorMessageForQuestionaireforHollywood">
								{{ errorMessageForQuestionaireforHollywood }}
							</div>


							<div class="text-center">
								<button class="btn buttonInquestionaire" (click)="submitTheQuestionaireforHollywood()">
									Get Started
								</button>
							</div>

						</div>
					</div>
				</div>
			</div> -->
			<!-------------------------------End Question Section For Hollywood------------------------------------------>


			<!-- newMiddleSection -->
			<div class="goto-premium text-center"
				*ngIf="newMiddleSection && !questionSection && globalServices?.isLoggedIn && !thankYouSectionFlag">
				<div class="container">
					<div class="main-heading">
						<h2 class="main-title text-capitalize">
							Our Memberships
						</h2>
						<h5 class="h5Heading">
							How much would you like to save ?
						</h5>
						<h6 class="h6Heading" *ngIf="isTrialUsed !== 1">
							Payment only begins once your 7-day free trial has ended.
							<br />
							Cancel anytime, for free, online.
						</h6>
					</div>
					<div class="premium-plan d-md-flex">
						<div class="premium-banner d-none d-md-block">
							<img src="assets/images/premium-banner.jpg" alt="mylifewell">
						</div>

						<div class="plan-detail  text-center forNewPlanDesign">

							<div class="planChooseOne">
								Choose One:
							</div>
							<div class="planBox2" [style.border]="flagForDiscountPlan ? '3px solid black' : '' ">
								<div class="planType">
									STANDARD MONTHLY
								</div>
								<div class="rate">
									$14.90/month
								</div>
								<div class="andGet">
									LIMITED TIME TRAVEL BONUS!
								</div>
								<div class="chargeAfterPlan">
									Signup by July 31 2021 and get:
								</div>
								<div class="rateAfter">
									every month
								</div>
								<ul class="plan-list">
									<li>
										<em class="tick-icn">
											<img src="assets/images/tick-green-icn.png" alt="mylifewell">
										</em>
										<!-- One personalized and customized Wellness Vacation Plan done by one of our TravelWell experts for an upcoming trip -->
										One customized Wellness Vacation designed by our Travel experts for free
										<br />
										($100 USD value)
									</li>
								</ul>
								<div class="plus">
									+ PLUS +
								</div>
								<ul class="plan-list">
									<li>
										<em class="tick-icn">
											<img src="assets/images/tick-green-icn.png" alt="mylifewell">
										</em>
										5% discount on the total vacation package price
									</li>
								</ul>
								<button class="btn btnSelect"
									(click)="planSelected(0);monthlyPlanSelected(planInfo?.data?._id)">
									SELECT
								</button>
							</div>
							<ng-container *ngIf="!flagForDiscountPlan">
								<ng-container *ngFor="let i of planDurationObject;">
									<div class="planBox1" *ngIf="i?.type != 'monthly' && i?.price">
										<span class="discount-bg">
											<img src="assets/images/discount-bg.png" alt="bgMyLifeWell">
											<span class="discount-txt text-uppercase">
												EXPIRES OCT 15
											</span>
										</span>
										<span class="discount-bg2">
											<span class="discount-txt2 text-uppercase">
												EXPIRES
												<br />
												OCT 15
											</span>
										</span>
										<div class="planType" *ngIf="i?.type == 'quarterly'">
											STANDARD QUARTERLY
										</div>
										<div class="planType" *ngIf="i?.type == 'yearly'">
											ANNUAL PLAN
										</div>
										<div class="save" *ngIf="i?.type == 'quarterly'">
											SAVE 25%
										</div>
										<div class="save" *ngIf="i?.type == 'yearly'">
											SAVE 40%
										</div>
										<div class="rateCut">
											<s *ngIf="i?.type == 'quarterly'">
												$14.90/mo
											</s>
											<s *ngIf="i?.type == 'yearly'">
												$238.80
											</s>
										</div>
										<div class="rate" *ngIf="i?.price">
											<span *ngIf="i?.type == 'quarterly'">
												${{(i?.price/3) | number:'1.2-2' }}/mo
											</span>
											<div *ngIf="i?.type == 'quarterly'" class="borderBottom">
											</div>
											<span *ngIf="i?.type == 'yearly'">
												${{(i?.price) | number:'1.2-2' }}/yr
											</span>
											<br />
											<span class="billedAnnualy" *ngIf="false && i?.type == 'quarterly'">
												every 3 months
											</span>
											<span class="billedAnnualy" *ngIf="false && i?.type == 'yearly'">
												every year
											</span>
										</div>
										<div class="chargeAfterPlan" *ngIf="i?.type == 'quarterly'">
											Save an
										</div>
										<div class="extraFifty">
											<span class="firstSpan">
												EXTRA 50% OFF
											</span>
											<br />
											<span class="secondSpan">
												Use code: BACKTOSCHOOL
											</span>
										</div>
										<div class="andGet" *ngIf="i?.type == 'quarterly'">
											and pay only $7.45/mo
										</div>
										<div class="signUpBy">
											Signup by July 31 2021 and get:
										</div>
										<ul class="plan-list">
											<li>
												<em class="tick-icn">
													<img src="assets/images/tick-green-icn.png" alt="mylifewell">
												</em>
												One customized Wellness Vacation designed by our Travel experts for free
												<br />
												($100 USD value)
											</li>
										</ul>
										<div class="plus">
											+ PLUS +
										</div>
										<ul class="plan-list">
											<li>
												<em class="tick-icn">
													<img src="assets/images/tick-green-icn.png" alt="mylifewell">
												</em>
												5% discount on the total vacation package price
											</li>
										</ul>
										<button *ngIf="i?.type == 'yearly'" class="btn saveBtn"
											(click)="planSelected(1);monthlyPlanSelected(planInfo?.data?._id)">
											SELECT
										</button>
										<button *ngIf="i?.type == 'quarterly'" class="btn saveBtn"
											(click)="planSelected(2);monthlyPlanSelected(planInfo?.data?._id)">
											SELECT
										</button>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
					<div *ngIf="isTrialUsed !== 1">
						<h6 class="h6Heading" style="margin-top: 40px;">
							Your first 7 days are completely FREE.
							<br />
							You can cancel your membership at any time.
						</h6>
					</div>
				</div>
			</div>








			<!-- showThirdStep -->
			<div class="w-100" *ngIf="showThirdStep  && !newMiddleSection && !b2b">
				<span class="w-100">
					<span class="backOption"
						*ngIf="(!flagForDiscountPlan && type == 'monthly') || (!flagForDiscountPlan && type == 'quarterly') "
						(click)="backToPlanSection()">
						Back to plan selection
					</span>
				</span>
			</div>
			<h4 class="congrats-msg text-center mt-5" *ngIf="showThirdStep  && !newMiddleSection && !b2b">
				<span *ngIf="(isTrial != 1) || (isTrial == 1 && isPlanPurchased == 1)">
					Fill Details
				</span>
				<span *ngIf="isTrial && activeFreeTrial?.count >= 0 && isPlanPurchased != 1 ">
					Activate your
					<span *ngIf="activeFreeTrial?.durationType && activeFreeTrial?.count && isTrialUsed !== 1">
						{{ activeFreeTrial?.count }}
						{{ activeFreeTrial?.durationType }}
					</span>
					<span *ngIf="isPlanPurchased != 1 && isTrial == 1 && isTrialUsed !== 1" style="margin-left: 3px;">
						Free
					</span>
					membership now
				</span>
			</h4>
			<!-- showThirdStep -->
			<div class="pc-details d-flex justify-content-between flex-wrap"
				*ngIf="showThirdStep && !newMiddleSection && !b2b">
				<div class="payment-details d-md-flex w-100">
					<div class="payment-form plain-payment">
						<h2 class="detail-title text-center">
							Plan Detail
						</h2>
						<form>
							<ng-container *ngFor="let obj of subscriberdata;let i=index">
								<!-- If User have  months Free Memberhsip -->
								<div class="plain-price-bx d-flex align-items-center justify-content-between"
									*ngIf="obj && obj['price']!=null && obj['price']!=undefined && obj['price']>=0 && isPlanPurchased != 1 && isTrial == 1 && isTrialUsed != 1">
									<p class="desc" *ngIf="isPlanPurchased != 1 && isTrial == 1 && isTrialUsed != 1">
										<span class="text-center startYour3MonthCss">
											Start Your
											<span *ngIf="activeFreeTrial?.durationType && activeFreeTrial?.count"
												style="text-transform: capitalize;">
												{{ activeFreeTrial?.count }}
												{{ activeFreeTrial?.durationType }}
											</span>
											<span *ngIf="isTrial && isPlanPurchased != 1" class="marginLeft3">
												Free
											</span>
											Trial
										</span>
										<span style="margin-top: 10%;font-weight: 600;"
											class="firstCapital padding15InMobile">
											<span *ngIf="isTrial && isPlanPurchased != 1">
												Free Trial +
											</span>
											{{ obj['subscriptionType'] === 'yearly' ? 'Annual' : obj['subscriptionType']
											}}
											Subscription
										</span>
										<span style="margin-top: 10%;">
											{{ obj['subscriptionName'] }}
										</span>
										<span class="sub-txt d-block firstCapital">
											<!-- ( {{ type | lowercase }} ) -->
											({{obj['subscriptionType'] === 'yearly' ? 'Annual' : obj['subscriptionType']
											}}
											<small *ngIf="obj['isTrial'] && !userSubscriptionResult['isTrialUsed']"
												class="firstCapital">
												after
												<!-- 30 Day  -->
												<span *ngIf="activeFreeTrial?.durationType && activeFreeTrial?.count">
													{{ activeFreeTrial?.count }}
													{{ activeFreeTrial?.durationType }}
												</span>
												<span *ngIf="isTrial  && isPlanPurchased != 1" class="marginLeft3">
													free trial
												</span>
											</small>)
										</span>
										<br>
										<br>
										<span class="" style="font-size: 14px;">
											Pay Today
											<span class="margin220pxInMobile"
												[style]="activeFreeTrial?.durationType == 'day' ? 'margin-left: 125px;' : 'margin-left: 125px;'">
												$0.00
											</span>
											<br /><br />
											After Trial
											<span style="float: right;">
												{{
												(( obj['Originalprice'] != null && obj['Originalprice'] != undefined ) ?
												getRound(obj['Originalprice']) :
												'') | currency:'USD':'symbol':'1.2-2'
												}}/
												{{ obj['subscriptionType'] == "monthly" ? "mo" : ""}}
												{{ obj['subscriptionType'] == "yearly" ? "yr" : ""}}
												{{ obj['subscriptionType'] == "quarterly" ? "qr" : ""}}
											</span>
											<br />
											<span *ngIf="discPercent && DiscountPrice">
												Less
												<span *ngIf="discountType == 'flat'">
													Flat
												</span>
												<span *ngIf="discountType != 'flat'">
													{{ discPercent }}%
												</span>
												Discount
												<span class="discountAmount" *ngIf="discountType != 'flat'">
													-{{ DiscountPrice | currency:'USD':'symbol':'1.2-2' }}
												</span>
												<span class="discountAmount" *ngIf="discountType == 'flat'">
													{{ DiscountPrice | currency:'USD':'symbol':'1.2-2' }}
												</span>
											</span>
											<br />
											AFTER TRIAL TOTAL
											<span style="float: right;">
												{{
												(( obj['Originalprice'] != null && obj['Originalprice'] != undefined ) ?
												( getRound(obj['Originalprice']) - DiscountPrice ) :
												'') | currency:'USD':'symbol':'1.2-2'
												}}/{{ obj['subscriptionType'] == "monthly" ? "mo" : ""}}
												{{ obj['subscriptionType'] == "yearly" ? "yr" : ""}}
												{{ obj['subscriptionType'] == "quarterly" ? "qr" : ""}}
											</span>
										</span>
										<br>
									</p>
								</div>
								<!-- If user already taken trial -->
								<div class="plain-price-bx d-flex align-items-center justify-content-between"
									*ngIf="obj && obj['price']!=null && obj['price']!=undefined && obj['price']>=0 && isTrial == 1 && isTrialUsed == 1">
									<p class="desc alreadyTakenTrial" *ngIf="isTrial == 1 && isTrialUsed == 1">
										<span class="text-center startYour3MonthCss">
											Start Your Membership
										</span>
										<span style="margin-top: 10%;font-weight: 600;"
											class="firstCapital padding15InMobile">
											{{ obj['subscriptionType'] === 'yearly' ? 'Annual' : obj['subscriptionType']
											}}
											Subscription
											<br>
											( {{ obj['subscriptionName'] }} )
											<span class="planPriceAfterTrial">
												{{
												(( obj['Originalprice'] != null && obj['Originalprice'] != undefined ) ?
												getRound(obj['Originalprice']) :
												'') | currency:'USD':'symbol':'1.2-2'
												}}/
												{{ obj['subscriptionType'] == "monthly" ? "mo" : ""}}
												{{ obj['subscriptionType'] == "yearly" ? "yr" : ""}}
												{{ obj['subscriptionType'] == "quarterly" ? "qr" : ""}}
											</span>
										</span>
										<br>
										<br>
									</p>
								</div>
								<!-- If user have wellness voyger plan without trial -->
								<div class="plain-price-bx d-flex align-items-center justify-content-between"
									*ngIf="obj && obj['price']!=null && obj['price']!=undefined && obj['price']>=0 && isPlanPurchased != 1 && isTrial == 0 && isTrialUsed != 1">
									<p class="desc" *ngIf="isPlanPurchased != 1 && isTrial == 0 && isTrialUsed != 1">
										<span style="margin-top: 5%;">
											{{ obj['subscriptionName'] }}
											<span class="priceOfPlan">
												{{
												(( obj['Originalprice'] != null && obj['Originalprice'] != undefined ) ?
												getRound(obj['Originalprice']) :
												'') | currency:'USD':'symbol':'1.2-2'
												}}/
												{{ obj['subscriptionType'] == "monthly" ? "mo" : ""}}
												{{ obj['subscriptionType'] == "yearly" ? "yr" : ""}}
												{{ obj['subscriptionType'] == "quarterly" ? "qr" : ""}}
											</span>
										</span>
										<span class="sub-txt d-block firstCapital">
											(
											{{obj['subscriptionType'] === 'yearly' ? 'Annual' : obj['subscriptionType']
											}}
											Subscription
											)
										</span>
									</p>
								</div>
							</ng-container>
							<div class="total-price-bx d-flex align-items-center justify-content-between"
								*ngIf="uniqueKey !== 'my-app' && discPercent && DiscountPrice">
								<p class="desc">
									Discount
								</p>
								<span class="price">
									( {{ discPercent }} % )
									{{ DiscountPrice | currency:'USD':'symbol':'1.2-2' }}
								</span>
							</div>
							<div class="total-price-bx d-flex align-items-center justify-content-between"
								*ngIf="uniqueKey == 'my-app' && discPercent && DiscountPrice && isTrialUsed == 1">
								<p class="desc">
									Discount
									<br>
									<span class="price" style="font-size: 14px;">
										Less
										<span *ngIf="discountType == 'flat'">
											Flat
										</span>
										<span *ngIf="discountType != 'flat'">
											{{ discPercent }}%
										</span>
										Discount
									</span>
								</p>
								<span class="price">
									<span *ngIf="discountType != 'flat'">
										-{{ DiscountPrice | currency:'USD':'symbol':'1.2-2' }}
									</span>
									<span *ngIf="discountType == 'flat'">
										{{ DiscountPrice | currency:'USD':'symbol':'1.2-2' }}
									</span>
								</span>
							</div>
							<div class="total-price-bx d-flex align-items-center justify-content-between">
								<p class="desc">
									Order Total
								</p>
								<span class="price" *ngIf="isTrialUsed == 1">
									<!-- (isTrial != 1) || (isTrial == 1 && isPlanPurchased == 1)  above line old condition -->
									{{ getRound(totalPrice-DiscountPrice) | currency:'USD':'symbol':'1.2-2'}}
								</span>
								<span class="price" *ngIf="isPlanPurchased != 1 && isTrial == 1 && isTrialUsed != 1">
									{{ 0 | currency:'USD':'symbol':'1.2-2'}}
								</span>
								<span class="price" *ngIf="isTrial ==  0 && isTrialUsed == 0">
									{{ getRound(totalPrice-DiscountPrice) | currency:'USD':'symbol':'1.2-2'}}
								</span>
							</div>
						</form>
					</div>
					<div class="payment-form">
						<form [formGroup]="paymentcard" id="customer-complete-purchse">
							<div class="various-platform">
								<ul
									class="online-platform d-flex justify-content-center justify-content-sm-between flex-wrap">
									<li>
										<a>
											<i class="icon-visaplatform"></i>
										</a>
									</li>

									<li>
										<a>
											<i class="icon-discover"></i>
										</a>
									</li>
									<li>
										<a>
											<i class="icon-mastercard"></i>
										</a>
									</li>
									<li>
										<a>
											<i class="icon-ae"></i>
										</a>
									</li>
								</ul>
							</div>

							<p style="padding:'10px';" *ngIf="isTrial && isPlanPurchased != 1 && isTrialUsed !== 1 ">
								Your card will not be charged during the free membership period. You can cancel your
								membership at
								anytime during or after the free membership period.
							</p>
							<p style="padding:'10px';">
								By starting my Membership, I confirm that I have read and agree to the
								<a class="cursorHand fontWt600" routerLink="/privacy_policy" target="_blank">
									Privacy Policy
								</a>
								&amp;
								<a class="cursorHand fontWt600" routerLink="/terms-conditions" target="_blank">
									Terms &amp; Conditions
								</a>
								and I authorize mylifewell to charge my payment method for the membership as described
								above.
							</p>
							<span [ngStyle]="{'color':'red'}">
								{{errorMessage}}
							</span>

							<button (click)="paymentForDiscount()" class="orderplace-btn"
								[disabled]="isPlanPurchased == 1 ? true : false"
								[style]="isPlanPurchased == 1 ? 'cursor:not-allowed': 'cursor: pointer'">
								Start Your Membership
							</button>
							<div>

							</div>

						</form>
					</div>
				</div>
				<div class="payment-banner plan-pricedetails">
					<div class="" *ngIf="subscriberdata && subscriberdata.length>0">

						<div class="note-msg" *ngIf="showplan && !userSubscriptionResult['isTrialUsed']">
							<h6 class="plan-title d-flex align-items-center justify-content-between">
								<strong>
									Start your
									<!-- 30 day  -->
									<span *ngIf="activeFreeTrial?.durationType && activeFreeTrial?.count">
										{{ activeFreeTrial?.count }}
										{{ activeFreeTrial?.durationType == "month" ? "mo": "" }}
									</span>
									free trial
								</strong>
							</h6>
							<p>*Please note:Your card will not be charged until the end of your free trial period
								{{expireTrialDate}}.
								You can cancel at anytime by logging into the "My Account" section.</p>
						</div>
						<!-- <h6 class="plan-title d-flex align-items-center justify-content-between"><strong>Plan Details</strong></h6> -->

						<!-- <h4 class="detail-title d-flex align-items-center justify-content-between">
							<strong>Plan Details</strong>
						</h4> -->
						<!-- <span [routerLink]="['/plan']"><img src="assets/images/edit-icn.png" alt="edit"></span> -->
						<!-- <ul class="list-view">
							<ng-container *ngFor="let obj of subscriberdata;let i=index">

								<li *ngIf="obj && obj['price']!=null && obj['price']!=undefined && obj['price']>0"
									class="price-set">
									{{obj['planUsename']}}
									<span class="name">
										<span>{{ obj['subscriptionName'] }}</span>
										<small>
											({{obj['subscriptionType'] === '' ? 'One-time' : obj['subscriptionType']}}
											<small
												*ngIf="false && obj['isTrial'] && !userSubscriptionResult['isTrialUsed']">
												after
												30 Day 
												<span *ngIf="activeFreeTrial?.durationType && activeFreeTrial?.count">
													{{ activeFreeTrial?.count }}
													{{ activeFreeTrial?.durationType == "month" ? "mo": "" }}
												</span>
												<span *ngIf="isTrial">
													free trial.
												</span>
											</small> )
										</small>
									</span>
									<span class="price">
										{{((obj['Originalprice']!=null &&
										obj['Originalprice']!=undefined)?getRound(obj['Originalprice']):'') |
										currency:'USD':'symbol':'1.2-2' }}
									</span>

									<span *ngIf="obj['planUsename']!=='plan'" class="delete-wrap">
                          <span class="delete" (click)="delData(obj['planUsename'],i)"><img src="assets/images/delete.svg" alt="delete">
                        </span> -->
						<!-- </span>
								</li>
							</ng-container>
						</ul> -->
						<!-- <div class="total-price d-flex align-items-center justify-content-between"
							*ngIf="((DiscountPrice && DiscountPrice>0))  ">
							<strong class="order-totaltext">Discounts</strong>
							<strong class="value-part">
								{{getRound(DiscountPrice) | currency:'USD':'symbol':'1.2-2'}}
							</strong>
						</div>
						<hr *ngIf="((DiscountPrice && DiscountPrice>0))"> -->
						<!-- <div class="total-price d-flex align-items-center justify-content-between"><strong class="order-totaltext">Applied code</strong><strong class="value-part">{{appliedCode}}</strong></div>
                    <hr> -->
						<!-- <div class="total-price d-flex align-items-center justify-content-between"
							*ngIf="totalPrice!=null && totalPrice!=undefined">
							<strong class="order-totaltext">Order Total</strong>
							<strong class="value-part">
								{{getRound(totalPrice-DiscountPrice) | currency:'USD':'symbol':'1.2-2'}}
							</strong>

						</div> -->
						<!-- <div class="final-checkout promo-checkout" *ngIf="(totalPrice-DiscountPrice)>0">
							<h2 class="text-capitalize">
								Apply Promo Code
							</h2>
							<form>
								<div class="promo-wrap">
									<button *ngIf="appliedCode" class="promo-button" (click)="removeCode('')">x</button>
									<input type="text" placeholder="enter promo code here" (keydown)="keyCheck($event)"
										[ngModelOptions]="{standalone: true}" [(ngModel)]="appliedCode">
									<i class="icon-gift"></i>
								</div>
								<button class="promo-submit" (click)="applyCode()">
									Apply
								</button>
								<span *ngIf="status" [ngStyle]="{'color':'#0a5fae','margin-left':'27px'}">
									{{status}}
								</span>
							</form>
						</div> -->
						<!-- until the end of your free trial period 11/20/2020 -->

					</div>
					<!-- <ul class="profit-points d-flex justify-content-between flex-wrap">
                    <li>No Booking Fees</li>
                    <li>best price guarantee</li>
                    <li>Free Cancellation Available</li>
                </ul> -->
				</div>
			</div>
			<!-- thankYouSectionFlag -->
			<h4 class="congrats-msg text-center"
				*ngIf="false && thankYouSectionFlag && !questionSection && globalServices?.isLoggedIn">
				<span>
					Thank You for joining !!
				</span>
			</h4>
		</div>
	</section>
	<div class="faq-section" *ngIf="showThirdStep && !newMiddleSection &&  !questionSection && !b2b">
		<div class="container">
			<div class="main-heading">
				<h2 class="main-title text-capitalize">Frequently Asked Questions</h2>
			</div>
			<ul class="faq-list">
				<li class="accordian" (click)="accordianChange(0)">
					<h3>Q. How do I activate the free 7-day membership?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							To activate your free trial, simply signup and complete your registration details. Once
							submitted, you'll
							get an email from us with your app download and login details so you can start enjoying
							three months of
							unlimited access.
						</p>
					</div>
				</li>
				<li class="accordian" (click)="accordianChange(1)">
					<h3>Q. How Is MyLifeWell Different Than Other Wellness Apps?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							Comprehensive: You probably have to subscribe to 3-4 different apps to find the right
							on-demand classes,
							guided meditations, social support groups, personal training, nutrition and caloric
							tracking. MyLifeWell
							brings everything together in one seamless app making it easier to adopt a wellness
							lifestyle in your
							day-to-day life.
							<br>
							<br>
							Variety: The MyLifeWell app offers 2000+ Yoga, HIIT, Barre, Kettlebell, Dance, Kick Boxing,
							Meditation,
							Cycling, Breathwork, Pilates and even Ballet bootcamp classes to choose from. Try something
							different each
							day and who knows, you may find a new passion! In addition, we offer 5000+ 3D animated
							videos for creating
							custom at-home and gym workouts.
							<br>
							<br>
							Quality: We make sure that you get only the best content across all categories.
						</p>
					</div>
				</li>
				<li class="accordian" (click)="accordianChange(2)">
					<h3>Q. Do I Need A Lot Of Equipment To Work Out?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							Not at all. We have a lot of classes that do not require any equipment. If you want to use
							an equipment
							then you can quickly filter the classes by different equipment options such as dumbell,
							kettlebell,
							resistance band and so on.
						</p>
					</div>
				</li>
				<li class="accordian" (click)="accordianChange(3)">
					<h3>Q. Do I have to be experienced to do the classes?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							Not at all. We have classes whether it’s your first time or you work out all the time. Start
							with where
							you’re at and build up from there, you’ll be surprised at how quickly you learn and grow.
						</p>
					</div>
				</li>
				<li class="accordian" (click)="accordianChange(4)">
					<h3>Q. I don’t have a lot of time, how long are the classes?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							We have classes ranging from 5 min to hour long fitness classes. So, whether you are looking
							for a quick
							10 min office workout or a 60 min full body workout, we have got you covered.
						</p>
					</div>
				</li>
				<li class="accordian" (click)="accordianChange(5)">
					<h3>Q. Do you have a rewards program?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							We will soon be launching a rewards program which means that not only will you be leading a
							healthier
							lifestyle but you will also be rewarded for it. Is there anything better?!!
						</p>
					</div>
				</li>
				<li class="accordian" (click)="accordianChange(6)">
					<h3>Q.If the first 7-day is free, why do I have to enter a credit card?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							When you sign up for your free 7-days of unlimited access, you are enrolling in a
							MyLifeWell subscription
							product. Your card will not be charged during the free month's membership period. At the end
							of the free
							membership period, the card will be charged per your subscription plan. You can cancel your
							membership at
							any time before or after the end of the free membership period.
						</p>
					</div>
				</li>
				<li class="accordian" (click)="accordianChange(7)">
					<h3>Q. What is the regular monthly cost after the 7-days Free Trial?
						<span class="plus-wrap"></span>
					</h3>
					<div class="faq-content">
						<p>
							The regular monthly membership fee is $14.90 USD/month.
						</p>
					</div>
				</li>
			</ul>
		</div>
	</div>
	<div class="enquiry-poup">
		<app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert"
			(triggerCloseEvent)="triggerCloseEvent()">
		</app-modal-pop-up>
		<app-pop-up-modal [responseMessage]="responseMessage2" *ngIf="showAlert2"
			(triggerCloseEvent)="triggerCloseEvent2($event)">
		</app-pop-up-modal>
	</div>
</section>
